export class TaskProgress {
    consumed: number = 0.0;
    progress: number = 0.0;
    remain: number = 0.0;
}